import React from 'react';
import ShareCalendar from '../components/ShareCalendar';

function SharePage({ refreshSharedUsers }) {
  return (
    <div className="page-container">
      <ShareCalendar refreshSharedUsers={refreshSharedUsers} />
    </div>
  );
}

export default SharePage;